import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getUserOrders } from '../../../store/actions/shared/Shared';
import moment from 'moment';
import Loader from 'react-loader-spinner';

class MyOrders extends Component {
  componentDidMount() {
    this.props.getUserOrders(localStorage.getItem('uid'));
  }

  render() {
    // var order = 'noty'
    var order = JSON.parse(localStorage.getItem('orderForDelivery'));
    // if(!localStorage.getItem('city')) return <Redirect to="/" />
    const orders = this.props.orders;

    return !this.props.loader ? (
     
      orders.map((order) => (
        <div className="container mb-5">
          <div className="cart-table">
            <div className="row">
              <div className="col-md-6 col-xs-12">
                <h3>Order Placed :</h3>
              </div>
              <div className="col-md-6 col-xs-12 mb-4">
                <h4> {moment(order.date).fromNow()} </h4>
              </div>
            </div>
            <div className="cart-table-warp" style={{ overflow: 'scroll' }}>
              <table>
                <thead>
                  <tr>
                    <th className="product-th">Product</th>
                    <th className="quy-th">Quantity</th>
                    <th className="total-th">Mode of Payment</th>
                    <th className="size-th">Price</th>
                  </tr>
                </thead>
                <tbody>
                  {!this.props.loader ? (
                    order.products.map((item) => (
                      <tr key={item.name}>
                        <td className="product-col">
                          <div className="frame">
                            <img
                              src={item.image}
                              alt=""
                              className="orderImage"
                            />
                          </div>
                          <div className="pc-title">
                            <h4>{item.name}</h4>
                            <p>{item.price}</p>
                          </div>
                        </td>
                        <td className="size-col">
                          <div className="quantity">
                            <div
                              className="pro-qty"
                              style={{
                                width: '30px',
                                borderRadius: '0',
                                height: '29px',
                                textAlign: 'center',
                                padding: '0'
                              }}
                            >
                              <span>{item.quantity} </span>
                            </div>
                          </div>
                        </td>
                        <td>
                          <h4> {order.paymentMode} </h4>
                        </td>
                        <td className="total-col">
                          <h4>${+item.quantity * +item.price}</h4>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <Loader
                      type="ThreeDots"
                      color="#d50000"
                      height={100}
                      width={100}
                      timeout={1000}
                      style={{ 'margin-left': '200px' }}
                    />
                  )}
                </tbody>
              </table>
            </div>
            <div
              className="total-cost"
              style={{
                background: 'linear-gradient(90deg,#16b790,#36ba92, #348e8c)'
              }}
            >
              <h6>
                SubTotal <span>${order.subTotal}</span>
              </h6>
              {order.discount ? (
                <h6>
                  Promo Code<span>-${order.discount}</span>
                </h6>
              ) : (
                <></>
              )}
              {order.tip ? (
                <h6>
                  Tip<span>-${order.tip}</span>
                </h6>
              ) : (
                <></>
              )}
              <h6>
                Final Total <span>${order.finalTotal}</span>
              </h6>
            </div>
          </div>
        </div>
      ))
    ) : (
      <Loader
        type="ThreeDots"
        color="#d50000"
        height={100}
        width={100}
        timeout={1000}
        style={{ 'margin-left': '200px' }}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  orders: state.shared.userOrders,
  loader: state.ui.user_loading
});

const mapDispatchToProps = (dispatch) => ({
  getUserOrders: (uid) => dispatch(getUserOrders(uid))
});

export default connect(mapStateToProps, mapDispatchToProps)(MyOrders);
